// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputfiles .inputfiles__file[data-v-173a4fc8]{display:grid;grid-template-columns:auto 50px;grid-column-gap:2rem;align-items:center}.inputfiles .inputfiles__file .deleting[data-v-173a4fc8]{opacity:.3}.inputfiles .inputfiles__addfile[data-v-173a4fc8]{display:flex;justify-content:center}.inputfiles button[data-v-173a4fc8]{padding:0;background-color:transparent;color:var(--dark-blue)}.inputfiles button[data-v-173a4fc8]:hover{color:var(--green)}", ""]);
// Exports
module.exports = exports;
